import * as yup from 'yup'
import { SupplementalDataType } from 'src/constants/oatfi-business/enums'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Validates the supplemental-document form before submit.
 *
 * Two rules mirror the wire contract exactly:
 *
 * - The file is `@GigsafeUploadedFile({ isRequired: true, fileType: 'pdf' })` on the backend, so
 *   it is required here. The `accept` attribute is a hint a determined user can bypass, which is
 *   why requiredness is enforced in the schema rather than left to the input.
 * - `invoiceId` is `@ValidateIf(type === Invoice) @IsUUID()`, so it is required *and* shaped only
 *   for that one type. `@IsUUID()` carries no version argument, which in class-validator means
 *   'all', so this pattern is deliberately version-agnostic rather than v4-only — a stricter
 *   pattern would reject ids the backend accepts.
 */
export const supplementalDataFormValidator = yup.object({
  type: yup
    .string()
    .trim()
    .oneOf(Object.values(SupplementalDataType), 'Select a document type')
    .required('Select a document type'),
  invoiceId: yup.string().when('type', {
    is: SupplementalDataType.Invoice,
    then: (schema) => {
      return schema
        .trim()
        .required('Enter the invoice ID')
        .matches(UUID_PATTERN, 'Enter a valid invoice ID')
    },
    otherwise: (schema) => {
      return schema.trim()
    },
  }),
  file: yup.mixed<File>().nullable().required('Choose a PDF to upload'),
})
